module.exports = __webpack_public_path__ + "static/media/logoPutih.38fe4788.png";